<page-load-header *ngIf="!initialized"></page-load-header>

<gait-analysis-walking-result-details [isCoachView]="false" [isShared]="true"></gait-analysis-walking-result-details>


